import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { request } from '@utils';
import { showErrorToast } from '@hooks/showErrorToast';

interface TransitProps {
  id: string;
}

export const useSendOneTransit = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id }: TransitProps) => {
      return request({
        path: `transits/${id}/send-transit-to-ncts`,
        method: 'POST',
        authenticate: true,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      toast.success(`Transit sent!`);
    },
    onError: (error) => {
      queryClient.invalidateQueries({ queryKey: ['transits'] });
      showErrorToast(error, `Error sending the transit!`);
    },
  });
};
